module.exports = __webpack_public_path__ + "static/media/leaderboards-2x.1a45fb31.png";